<span class="label"><ng-content /></span>

@if (removable()) {
  <button
    type="button"
    class="remove"
    [attr.aria-label]="removeLabel()"
    (click)="removed.emit()">
    <mat-icon>close</mat-icon>
  </button>
}
